// extracted by mini-css-extract-plugin
module.exports = {"contents":"_1Z4gLx2gql17ntUMCnUQzw","title":"_1l3_8EcS7wpySc-fX85PK_","text":"tgjvLp8dlXZ1MHRPFkUWP","modalText":"-s6rnqtB6kgCAt1xjwwIz"};